import React, { useState } from 'react';
import { AlertCircle, CheckCircle } from 'lucide-react';
import type { Resident } from '../types';

interface CheckPaymentsButtonProps {
  onClick: () => void;
  discrepancies: number;
}

export function CheckPaymentsButton({ onClick, discrepancies }: CheckPaymentsButtonProps) {
  const [isChecking, setIsChecking] = useState(false);
  
  const handleClick = () => {
    setIsChecking(true);
    setTimeout(() => {
      setIsChecking(false);
      onClick();
    }, 1000); // Simulate checking
  };

  return (
    <button
      onClick={handleClick}
      disabled={isChecking}
      className={`flex items-center gap-1 px-2.5 py-1.5 rounded-md text-white transition-colors text-xs font-medium ${
        discrepancies > 0 
          ? 'bg-yellow-500 hover:bg-yellow-600' 
          : 'bg-green-500 hover:bg-green-600'
      }`}
    >
      {isChecking ? (
        <>
          <div className="animate-spin h-3.5 w-3.5 border-2 border-white border-t-transparent rounded-full" />
          <span className="hidden xs:inline">Memeriksa...</span>
        </>
      ) : (
        <>
          {discrepancies > 0 ? (
            <>
              <AlertCircle className="h-3.5 w-3.5" />
              <span className="hidden xs:inline">Periksa ({discrepancies})</span>
              <span className="xs:hidden">({discrepancies})</span>
            </>
          ) : (
            <>
              <CheckCircle className="h-3.5 w-3.5" />
              <span className="hidden xs:inline">Periksa</span>
              <span className="xs:hidden">✓</span>
            </>
          )}
        </>
      )}
    </button>
  );
}